import { UseCase } from "../../useCase"
import { GetTournamentMembersResponse } from "./response"
import { GetTournamentMembersRequest } from "./request"
import { SellerServicesRepository } from "../../../repositories/sellerServicesRepository"

export class GetTournamentMembersUseCase implements UseCase<GetTournamentMembersRequest, GetTournamentMembersResponse> {
	private _repository
	constructor({ SellerServicesRepository }: { SellerServicesRepository: SellerServicesRepository }) {
		this._repository = SellerServicesRepository
	}

	exec({ serviceId }: GetTournamentMembersRequest) {
		return this._repository.getTournamentMembers(serviceId)
	}
}
